import React, { useState, useContext, useEffect } from 'react';
import TableBits from '../TableBits/TableBits';

import Box from '@mui/material/Box';
import { Grid } from "@material-ui/core";
import SearcherEvaluationModel from './Components/SearcherEvaluationModel';
import BtnCreate from './Components/BtnCreate';
import MenuList from './Components/MenuList';
import columns from './EvaluationModelColumns';
import CheckPermission from '../../helpers/Administradores/Permissions';
import { createEvaluationModelModal } from '../../context/PerformanceEvaluationContext/Actions';
import PerformanceEvaluationContext from '../../context/PerformanceEvaluationContext/PerformanceEvaluationContext';
import ModalCreateEvaluationModel from './modals/ModalCreateEvaluationModel';
import './css/CreateEvaluationModel.css';
import { GET_ALL_MODELS_EVALUATION } from '../../Querys/querys';
import { useQuery } from '@apollo/client';
import EliminaModelEvaluation from './modals/EliminaModelEvaluation';

const ModelPerformanceEvaluation = () => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [initialRows, setInitialRows] = useState([]);
  const { dispatch } = useContext(PerformanceEvaluationContext)
  const { data: resultModels,loading } = useQuery(GET_ALL_MODELS_EVALUATION)
  const allModels = resultModels?.GET_ALL_MODELS_EVALUATION

  const openCreateModal = () => {
    createEvaluationModelModal('0',true, dispatch)
  }

  useEffect(() => {
    if(resultModels?.GET_ALL_MODELS_EVALUATION){
    if (allModels.length > 0 ) {
      setFilteredRows(allModels) 
      setInitialRows(allModels)
    }
  }
  }, [allModels, resultModels?.GET_ALL_MODELS_EVALUATION]);

  return (
    <>
    <div className="c_contenedorPrincipal">
      <Box display="flex" flexDirection="column" p={4}>
        <Grid container className="screenBtns">
          <div className='surveyTitle'>Modelos  de evaluación</div>
          {CheckPermission("EvalDesempenio.ModelosDeEvaluacion.Crear") && (
            <BtnCreate 
              txtBtn="Crear modelo de evaluación" 
              openModal={openCreateModal}
            />
          )}
        </Grid>
         {(loading === true) ?
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
        :<>
        <Box pb={3} pt={1}>
          <SearcherEvaluationModel
            setFilteredRows={setFilteredRows}
            initialRows={initialRows}
            width={300}
          />
        </Box>
         {
         filteredRows.length > 0 ? (
        <TableBits
          columns={columns}
          rows={filteredRows}
          components={[
            null,
            null,
            null,
          ]}
          componentOptions={MenuList}
          customInitialOrderBy='name'
          customInitialOrder='asc'
          customRowsPerPage={10}
        />):
         <div className="contenedorMensajeCarga">
            <div className="mensajeCarga"> Comienza a crear Modelos de evaluación</div>
          </div>
          }
        </>
        } 
      </Box>
    </div>
    <ModalCreateEvaluationModel />
    <EliminaModelEvaluation />
    </>
  )
}

export default ModelPerformanceEvaluation